import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { PlayerTrack } from 'store/player/reducer.types';

import { AudioTrackEncodeType } from 'components/Player/types';

type Params = {
    item: PlayerTrack;
    onPress?(item: PlayerTrack): void;
    isAudio?: boolean;
};

function useAudioAndSubtitleOption({ item, onPress, isAudio }: Params) {
    const { SCREEN_SUBTITLE_OFF, SUBTITLE_OTT_HEARING_IMPAIRED_TRUE } =
        LANGUAGE_KEYS;
    const { t } = useTranslation();
    const { language, title, encodeType, characteristics, channelCount } = item;

    const languageName = `${isAudio ? 'AUDIO' : 'SUBTITLES'}_LANGUAGE_OTT_${(
        language || title
    ).toUpperCase()}`;
    const audioEncoding =
        isAudio &&
        Object.entries(AudioTrackEncodeType).find(
            ([, value]) => value === encodeType && encodeType !== 1000,
        );
    const audioChannelValue =
        isAudio && channelCount && t(`AUDIO_AUDIO_CHANNEL_OTT_${channelCount}`);
    const subtitlesAccessability =
        !isAudio &&
        characteristics?.length &&
        t(SUBTITLE_OTT_HEARING_IMPAIRED_TRUE);
    const additionalInfo =
        `${audioEncoding ? audioEncoding[0] : ''}${
            audioChannelValue ? `, ${audioChannelValue}` : ''
        }` || subtitlesAccessability;

    const optionName = `${t(
        title === SCREEN_SUBTITLE_OFF
            ? SCREEN_SUBTITLE_OFF
            : // @ts-ignore
              languageName,
    )}${additionalInfo ? `, ${additionalInfo}` : ''}`;

    const handlePress = useCallback(() => {
        if (onPress) {
            onPress(item);
        }
    }, [item, onPress]);

    return { optionName, onPress: handlePress };
}

export default useAudioAndSubtitleOption;
